// company constants
import DIVERSITIES from '../constants/diversities.constant.company';

const getFullDiversity = ({diversity, empty = '-'}) =>
  DIVERSITIES?.[diversity] || empty;

export default getFullDiversity;
